import React, { Component } from 'react';
import { TabPanel } from '@wordpress/components';
import Gmap from './gmap.jsx'
import Elements from './eaeElements.jsx'
import Products from './products.jsx'

export default class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: 'false'
        }
    }

    set_load_status(status){
        this.setState({loading:status});
    }
    render() {
        return[
            <div className="eae-data-wrapper">
                <div className="eae-headBar">
                    <div className="eae-logo">
                        Elementor Addons Elements
                    </div>
                    <div className="eae-menu">
                        <span className={'eae-version'}>{`Version : ${eaeGlobalVar.eae_version}`}</span>
                    </div>
                </div>
                <div className="eae-settings-wrapper">
                    <TabPanel className={`eae-setting-tabs ${ this.state.loading === 'true' ? 'loading' : 'loaded'}`}
                              activeClass="eae-active"
                              //onSelect={ onSelect }
                              tabs={ [
                                  {
                                      name: 'eae-elements',
                                      title: 'Elements',
                                      className: 'eae-tab-elements',
                                  },
                                  {
                                      name: 'eae-gmap',
                                      title: 'Configuration',
                                      className: 'eae-tab-configuration',
                                  },
                                  {
                                      name: 'eae-products',
                                      title: 'Other Products',
                                      className: 'eae-tab-product',
                                  },
                              ] }>
                                {
                                    ( tab ) => [
                                                   tab.name === 'eae-gmap' && (
                                                       <Gmap set_status={this.set_load_status.bind(this)}/>
                                                   ),
                                                   tab.name === 'eae-elements' && (
                                                       <Elements set_status={this.set_load_status.bind(this)}/>
                                                   ),
                                                   tab.name === 'eae-products' && (
                                                       <Products/>
                                                   )
                                                ]
                                }
                    </TabPanel>
                </div>
            </div>

            ]
    }
}
